import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { db, auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, onSnapshot } from 'firebase/firestore';
import './Header.css';
import logo from '../logo-assets/GIEPEI - HORIZONTAL-ok.png';

const Header: React.FC = () => {
  const [registrationOpen, setRegistrationOpen] = useState(true);
  const [user, setUser] = useState(auth.currentUser);

  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });

    // Escuchar cambios en la configuración en tiempo real
    const unsubscribeSettings = onSnapshot(doc(db, 'settings', 'main'), (snap) => {
      if (snap.exists()) {
        setRegistrationOpen(snap.data().registrationOpen !== false);
      }
    });

    return () => {
      unsubscribeAuth();
      unsubscribeSettings();
    };
  }, []);

  return (
    <header className="main-header">
      <div className="container header-container">
        <Link to="/" className="logo-link">
          <img src={logo} alt="GIEPEI Logo" className="header-logo" />
        </Link>
        <nav className="main-nav desktop-only">
          <ul>
            <li><Link to="/">Início</Link></li>
            <li><Link to="/publicacoes">Publicações</Link></li>
            {registrationOpen && <li><Link to="/inscricao">Inscrições</Link></li>}
            <li><Link to="/sobre-nosotros">Sobre o GIEPEI</Link></li>
            <li><Link to="/contacto">Contacto</Link></li>
          </ul>
        </nav>

        <div className="header-actions">
          <Link to={user ? "/perfil" : "/acesso"} className="btn btn-outline btn-sm" style={{ marginRight: '10px' }}>
            {user ? "Minha Conta" : "Participante"}
          </Link>
          <Link to="/admin" className="btn btn-primary btn-sm">Admin</Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
